/** First Seen maps to certificate notBefore in the UI. */
export function certificateFirstSeenMs(cert) {
  if (!cert?.notBefore) return 0;
  const t = new Date(cert.notBefore).getTime();
  return Number.isNaN(t) ? 0 : t;
}

export function compareCertificatesByFirstSeenDesc(a, b) {
  return certificateFirstSeenMs(b) - certificateFirstSeenMs(a);
}

export function sortCertificatesByFirstSeen(certs) {
  return [...(certs || [])].sort(compareCertificatesByFirstSeenDesc);
}
